export const GENERIC_CHECKOUT_ERROR_MESSAGE =
  'There was a problem processing your order. Please check your details and try again.';

export const ORDER_IN_PROGRESS_ERROR_MESSAGE =
  'Your order is already in progress. Check back soon for details.';

export const ORDER_VEHICLE_NOT_AVAILABLE_TITLE = 'Vehicle not available';

export const ORDER_VEHICLE_NOT_AVAILABLE_MESSAGE =
  'Looks like this vehicle is no longer available. Explore our available inventory to find your next Flexcar.';

export const ORDER_MARKET_VEHICLE_INVALID_TITLE = 'Market and Vehicle do not match';

export const ORDER_MARKET_VEHICLE_INVALID_MESSAGE =
  "Looks like this vehicle isn't available in your area. Explore our inventory to find your next Flexcar.";

export const PRICING_CHANGE_TITLE = 'Pricing change';

export const PRICING_CHANGE_MESSAGE =
  'The price of your Flexcar changed before you completed your purchase. Please review the new total and try again.';

export const DEDUCTIBLE_CHANGE_TITLE = 'Your protection plan deductibles have changed';
